<template>
  <div :class="class_name">
    <div v-for="post in posts.list" :key="post.id" class="card">
      <Transition name="fade">
        <post-card :title="post.title" :permalink="post.permalink" :image="post.image"></post-card>
      </Transition>
    </div>
    <div v-if="posts.list.length === 0">no results</div>
  </div>
</template>

<script>
import { reactive } from "vue";
import PostCard from "./PostCard.vue";

export default {
  components: {
    PostCard,
  },
  props: ["posts", "class_name"],
  setup(props) {
    const posts = reactive(props.posts);

    return {
      posts,
    };
  },
};
</script>
